import type { CSSProperties } from "react";

export type ReportThemeOverride = "active" | "beflow-light";

type ReportThemeStyle = CSSProperties & Record<`--report-${string}`, string>;

const ACTIVE_REPORT_THEME: ReportThemeStyle = {
  "--report-bg": "var(--card)",
  "--report-fg": "var(--card-foreground)",
  "--report-muted": "var(--muted)",
  "--report-muted-fg": "var(--muted-foreground)",
  "--report-border": "var(--border)",
  "--report-accent": "var(--brand-accent)",
  "--report-accent-soft": "color-mix(in srgb, var(--brand-accent) 12%, transparent)",
  "--report-info": "var(--secondary)",
  "--report-risk": "var(--destructive)",
};

const BEFLOW_LIGHT_REPORT_THEME: ReportThemeStyle = {
  colorScheme: "light",
  "--report-bg": "#ffffff",
  "--report-fg": "#142c4a",
  "--report-muted": "#f4f6f8",
  "--report-muted-fg": "#52677d",
  "--report-border": "#dce3e8",
  "--report-accent": "#f27127",
  "--report-accent-soft": "#fff0e7",
  "--report-info": "#037fb9",
  "--report-risk": "#c43e21",
};

export function reportThemeStyle(theme: ReportThemeOverride): ReportThemeStyle {
  // prefers-reduced-motion is honored in CSS for charts/transitions; the theme
  // tokens themselves remain static (no motion properties).
  return theme === "beflow-light" ? BEFLOW_LIGHT_REPORT_THEME : ACTIVE_REPORT_THEME;
}

export const REPORT_CHART_PALETTE = [
  "#f27127",
  "#037fb9",
  "#6d5bd0",
  "#2c8c69",
  "#c45b8e",
  "#a26a00",
  "#4b748b",
  "#8a5a44",
] as const;
